import { CompanyDetailsInterface } from '../../../services/exports/Interfaces';
import dayjs, { BusinessHoursMap } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

type Props = {
  workSchedule: NonNullable<CompanyDetailsInterface['work_schedule']>;
  companyTz: string;
  userTz: string;
  scheduleAheadTime?: number;
  lastOrderGap?: number;
  withTimeOffsets?: boolean;
};

export const buildBusinessTimes = ({
  scheduleAheadTime,
  workSchedule,
  lastOrderGap,
  userTz,
  companyTz,
  withTimeOffsets,
}: Props): BusinessHoursMap => {
  const businessTimes: BusinessHoursMap = {
    monday: null,
    tuesday: null,
    wednesday: null,
    thursday: null,
    friday: null,
    saturday: null,
    sunday: null,
  };

  const weekStart = dayjs().tz(companyTz).startOf('week');

  for (const entry of workSchedule) {
    let openTime = weekStart
      .clone()
      .add(entry.open.day, 'days')
      .hour(entry.open.hour)
      .minute(entry.open.minute)
      .second(0)
      .millisecond(0)
      .tz(userTz);
    let closeTime = weekStart
      .clone()
      .add(entry.close.day, 'days')
      .hour(entry.close.hour)
      .minute(entry.close.minute)
      .second(0)
      .millisecond(0)
      .tz(userTz);

    if (withTimeOffsets) {
      openTime = openTime.add(scheduleAheadTime, 'minute');
      closeTime = closeTime.subtract(lastOrderGap, 'minute');
    }

    const openKey = openTime.locale('en').format('dddd').toLowerCase();
    const closeKey = closeTime.format('dddd').toLowerCase();
    const start = openTime.format('HH:mm:ss');
    const end = closeTime.format('HH:mm:ss');

    if (openKey === closeKey) {
      businessTimes[openKey] ??= [];
      businessTimes[openKey].push({ start, end });
      continue;
    }

    businessTimes[openKey] ??= [];
    businessTimes[openKey].push({ start, end: '23:59:59' });

    businessTimes[closeKey] ??= [];
    businessTimes[closeKey].push({ start: '00:00:00', end });
  }

  return businessTimes;
};
